import i18n from '@/plugins/i18n';

const parseToGiB = (value) => (value ? value / 1073741824 : value);

export const nodeCardData = [
  {
    metricName: 'gke_cluster_cpu_cores',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.cpuCores'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'gke_cluster_cpu_allocatable_cores',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.cpuAllocatableCores'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'gke_cluster_cpu_allocatable_utilization',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.cpuAllocatableUtilization'),
    textValColor: 'tangerine',
    textValue: '0',
    transform: (value) => (value ? value / 100 : value),
  },
  {
    metricName: 'gke_cluster_nodes_total',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.nodesTotal'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'gke_cluster_memory_total_bytes',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.memoryTotalBytes'),
    textValColor: 'tangerine',
    textValue: '0',
    unit: 'GiB',
    transform: parseToGiB,
  },
  {
    metricName: 'gke_cluster_memory_total_used_bytes',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.memoryTotalUsedBytes'),
    textValColor: 'tangerine',
    textValue: '0',
    unit: 'GiB',
    transform: parseToGiB,
  },
  {
    metricName: 'gke_cluster_storage_total_bytes',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.storageTotalBytes'),
    textValColor: 'tangerine',
    textValue: '0',
    unit: 'GiB',
    transform: parseToGiB,
  },
  {
    metricName: 'gke_cluster_storage_total_used_bytes',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('GcpK8.storageTotalUsedBytes'),
    textValColor: 'tangerine',
    textValue: '0',
    unit: 'GiB',
    transform: parseToGiB,
  },
];
